function ltAppear() {
  var windowViewHeight = $(window).height()
  function windowScrollTopFn() {
    let windowScrollTop = $(window).scrollTop()
    $('.appear-k').each(function () {
      let $this = $(this)
      if (
        $this.offset().top >= windowScrollTop - 400 &&
        $this.offset().top <= windowScrollTop + windowViewHeight
      ) {
        $this.addClass('an-down')
      }
    })
  }
  // 响应滚动事件
  $(window).scroll(windowScrollTopFn)

  // 响应缩放事件
  $(window).resize(function () {
    windowViewHeight = $(window).height()
    windowScrollTopFn()
  })

  windowScrollTopFn()
}

function refreshCartDrawer() {
  return new Promise((res, rej) => {
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      success: function () {
        // 将更新后的购物车内容渲染到购物车抽屉的显示区域
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh:opend', { bubbles: true })
        )
        res(true)
      },
      error() {
        rej(false)
      },
    })
  })
}

async function addStarProduct(data, cb) {
  const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  const json = await response.json()
  if (cb) cb()
  return await refreshCartDrawer(json)
}

const loadingSvg = `<svg width="32" height="32" remove-icon viewBox="0 0 14 10"><use xlink:href="#loading"></use></svg>`

function cartBtnLoading(el) {
  el.attr('disabled', true)
  el.addClass('loading')
  const icon = el.find('svg use')
  if (icon.length > 0) {
    icon.data('icon', icon.attr('xlink:href'))
    icon.attr('xlink:href', '#loading')
    return
  }
  const originInfo = el.html()
  el.html(`${loadingSvg}${originInfo}`)
}

function finishLoading(el) {
  el.attr('disabled', false)
  el.removeClass('loading')
  const icon = el.find('svg:not([remove-icon]) use')
  if (icon.length > 0) {
    icon.attr('xlink:href', icon.data('icon'))
    icon.removeData('icon')
    return
  }
  el.find('svg[remove-icon]').remove()
}

function formatData(data) {
  if (data.id) {
    return {
      items: [{ id: data.id, quantity: data.quantity || 1 }],
    }
  }
  return data
}

function ltAddToCart() {
  const cardData = $(this).data('lt-cart')
  if (!cardData.id && !cardData.items) return
  cartBtnLoading($(this))
  const data = formatData(cardData)
  addStarProduct(data).finally(() => {
    finishLoading($(this))
  })
}
function ltCopy() {
  const code = $(this).find('.code').text() || $(this).data('code')
  const btn = $(this).find('button')
  const beforeText = btn.text() || $(this).text()
  navigator.clipboard.writeText(code).then(function () {
    btn.text(btn.data('copied'))
    setTimeout(() => {
      btn.text(beforeText)
    }, 1000)
  })
}

function ltCopySelf() {
  const that = $(this)
  const code = that.data('code')
  const beforeText = that.text()

  navigator.clipboard.writeText(code).then(function () {
    that.text(that.data('copied'))
    setTimeout(() => {
      that.text(beforeText)
    }, 1000)
  })
}

// gobal function
ltLazyLoad(function () {
  ltAppear()
  $('button[data-lt-cart]').click(ltAddToCart)
  $('.lt-copy, .lt-copy-ny').click(ltCopy)
  $('[lt-copy]').click(ltCopySelf)
})
